import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithSnackbar } from './baseQueryWithSnackbar';

export const api = createApi({
    reducerPath: 'api',
    baseQuery: baseQueryWithSnackbar,
    tagTypes: ['Account', 'Tags', 'Entity', 'Points', 'TeamMember', 'Event', 'Category', 'Subscription', 'PaymentMethods', 'ParishBookPerson', 'ParishBookCategory', 'Announcement', 'Offer', 'EventRole'],
    endpoints: () => ({}),
});
